//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Preferences.js";
import "../no/ModelingView.js";
let d=[[[0,"DisplayTechnique",1,0],[0,"FacetsQuality",1,0],[0,"Format",1,0],[0,"Method",1,0],[0,"Shadows",1,0],[0,"UseIbl",1,0]],[[[],"Generate",{},0,0],[["image_file_name","compress_image"],"Save",{},2,0],[[],"Erase",{},0,0],[["resolution","dots_per_inch","plot_quality","plot_file_name"],"Plot",{},4,0],[[],"ShowImageInformation",{},0,0],[["number_bodies_rendered","number_faces_rendered","number_polygons_generated","polygon_generation_seconds","shadow_generation_seconds","image_generation_seconds"],"GetImageCounts",{},0,0]],[]];
SPLM.ModelingViewHighQualityImage = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ModelingViewHighQualityImage";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ModelingViewHighQualityImage.ShadeMethod = Object.freeze({
    "Flat" : "Flat", "Gouraud" : "Gouraud", "Phong" : "Phong", "Improved" : "Improved", "Preview" : "Preview", "PhotoRealistic" : "PhotoRealistic", "RayTraced" : "RayTraced", "RayTracedFfa" : "RayTracedFfa", "Radiosity" : "Radiosity", "HybridRadiosity" : "HybridRadiosity"});

SPLM.ModelingViewHighQualityImage.FormatType = Object.freeze({
    "RasterImage" : "RasterImage", "QtvrPanorama" : "QtvrPanorama", "QtvrObjectLow" : "QtvrObjectLow", "QtvrObjectHigh" : "QtvrObjectHigh"});

SPLM.ModelingViewHighQualityImage.DisplayTechniqueType = Object.freeze({
    "RgbPlusNoise" : "RgbPlusNoise", "FsRgb" : "FsRgb", "FsRgbPlusNoise" : "FsRgbPlusNoise", "Monochrome" : "Monochrome", "GrayScale" : "GrayScale", "NearestRgb" : "NearestRgb", "OrderedDither" : "OrderedDither", "TcPlusNoise" : "TcPlusNoise"});

export default SPLM;